import { render } from "./created.vue?vue&type=template&id=a5ce38d4&scoped=true"
import script from "./created.vue?vue&type=script&lang=js"
export * from "./created.vue?vue&type=script&lang=js"

import "./created.vue?vue&type=style&index=0&id=a5ce38d4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5ce38d4"]])

export default __exports__